<template>
  <div>
    <van-empty image="error" description="对不起，您正在寻找的页面不存在" />
  </div>
</template>

<script>
import { Empty } from 'vant';
export default {
  components:{
    [Empty.name]: Empty
  },

}
</script>

<style>

</style>